import { Link } from "react-router-dom";
import LegalPage, { H2, P, UL } from "@/components/LegalPage";
import { BUSINESS_ADDRESS, PHONE_DISPLAY } from "@/lib/whatsapp";

export default function Refund() {
  return (
    <LegalPage
      title="Refund & Cancellation Policy"
      effectiveDate="08 May 2026"
      path="/refund"
      description="The 7-day money-back guarantee, refund eligibility, processing timelines and cancellation rules for Weight Loss Gurukul programs."
    >
      <P>
        We want every client to start their transformation with confidence.
        This Refund Policy explains how cancellations and refunds work for
        paid programs offered by <strong>Weight Loss Gurukul</strong>{" "}
        ("we", "us", "our"). This Policy is part of, and should be read with,
        our{" "}
        <Link to="/terms" className="text-forest underline">
          Terms & Conditions
        </Link>
        .
      </P>

      <H2>1. 7-day money-back guarantee</H2>
      <P>
        Paid programs are backed by a <strong>7-day money-back guarantee</strong>{" "}
        starting from the day your program officially begins (your "Start
        Date"). If, within these 7 days, you decide the program is not the
        right fit, you can request a full refund — no awkward questions, no
        retention sales pitch.
      </P>

      <H2>2. Eligibility</H2>
      <UL>
        <li>You requested the refund within 7 calendar days of your Start Date.</li>
        <li>
          You attended your onboarding consultation and at least one live
          session, so we know we genuinely tried to make it work for you.
        </li>
        <li>
          You complied with our{" "}
          <Link to="/terms" className="text-forest underline">
            Terms & Conditions
          </Link>{" "}
          (in particular, no recording or sharing of session content).
        </li>
      </UL>

      <H2>3. What is not refundable</H2>
      <UL>
        <li>Free consultations — they have no fee to refund.</li>
        <li>Refund requests received after the 7-day window has passed.</li>
        <li>Programs where you have downloaded all proprietary materials within the first 7 days and then asked for a refund.</li>
        <li>Bank charges, payment-gateway fees and currency-conversion fees, where the processor does not return them to us.</li>
        <li>Any third-party purchases (e.g. mats, props, books) made via partner stores — those follow the partner's refund policy.</li>
      </UL>

      <H2>4. How to request a refund</H2>
      <P>
        Email{" "}
        <a className="text-forest underline" href="mailto:hello@weightlossgurukul.com">
          hello@weightlossgurukul.com
        </a>{" "}
        from the email address you used to enrol, with the subject line{" "}
        <em>"Refund request — [Program name]"</em>. Include your full name,
        program start date, payment reference and a short note on why the
        program isn't working for you (this helps us improve).
      </P>

      <H2>5. Processing time</H2>
      <P>
        Once approved, refunds are initiated within <strong>5 business days</strong>{" "}
        and credited back to the original payment method. Depending on your
        bank or card issuer, the amount may take an additional{" "}
        <strong>5–10 business days</strong> to reflect in your account.
        International payments may take slightly longer.
      </P>

      <H2>6. Cancellations after the 7-day window</H2>
      <P>
        After the 7-day window we do not offer pro-rated refunds for unused
        sessions. However, in cases of medical emergencies, bereavement or
        documented hardship, we may at our discretion pause your program or
        offer a credit towards a future enrolment. Email us — we read every
        message and respond personally.
      </P>

      <H2>7. Programs we cancel</H2>
      <P>
        If we cancel a program before it begins (for example, if a teacher is
        unavailable and we cannot find a substitute), you receive a full
        refund or, at your choice, a credit for a future program of equal or
        lesser value.
      </P>

      <H2>8. Disputes & chargebacks</H2>
      <P>
        Please write to us first — we resolve almost every concern in a single
        email. Initiating a chargeback before contacting us slows down
        resolution and may delay your refund.
      </P>

      <H2>9. Changes to this Policy</H2>
      <P>
        We may update this Policy from time to time. The "Effective date" at
        the top tells you when. The Policy in force on the day you enrol is
        the one that applies to that enrolment.
      </P>

      <H2>10. Contact</H2>
      <P>
        Weight Loss Gurukul<br />
        {BUSINESS_ADDRESS.line1}, {BUSINESS_ADDRESS.line2},{" "}
        {BUSINESS_ADDRESS.line3}, {BUSINESS_ADDRESS.line4}<br />
        Email:{" "}
        <a className="text-forest underline" href="mailto:hello@weightlossgurukul.com">
          hello@weightlossgurukul.com
        </a>{" "}
        · Phone: {PHONE_DISPLAY}
      </P>
    </LegalPage>
  );
}
